@import 'styles/mixins';
@import 'styles/variables';

.listItem {
  @include ui-md-text;
  padding: 11px 0;
  color: $grey-90;
}

.listItem + .listItem {
  border-top: 1px solid $gray-10;
}

.link {
  color: $almanac-black;
  display: flex;
}

.icon {
  vertical-align: middle;
  fill: $blue-40;
  margin-right: 6px;
  flex: none;
}

.emoji {
  margin-right: 8px;
}
